export const iconFontAwesomeArrowsCircleArrowRight = (
	<i className="fa-solid fa-circle-arrow-right"></i>
);
